export default "__VITE_ASSET__Cc0_o7UZ__"